module.exports = __webpack_public_path__ + "img/icon-warning-avalanches-yellow.3948a4f2.svg";